import { render } from "./ItemTrigger.vue?vue&type=template&id=021f5797"
import script from "./ItemTrigger.vue?vue&type=script&lang=js"
export * from "./ItemTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__